export default class UpdateActivityCategoryRequest {
    updatedAt: Date | string = '';
    name = '';
    description = '';
    color = '';
    isActive = true;
    sortOrder = 0;

    // Worker entity - which activity types this category is enabled for
    isEnabledOnWorkerTask = false;
    isEnabledOnWorkerNote = false;
    isEnabledOnWorkerCall = false;
    isEnabledOnWorkerMeeting = false;
    isEnabledOnWorkerEmail = false;

    // Company entity
    isEnabledOnCompanyTask = false;
    isEnabledOnCompanyNote = false;
    isEnabledOnCompanyCall = false;
    isEnabledOnCompanyMeeting = false;
    isEnabledOnCompanyEmail = false;

    // Location entity
    isEnabledOnLocationTask = false;
    isEnabledOnLocationNote = false;
    isEnabledOnLocationCall = false;
    isEnabledOnLocationMeeting = false;
    isEnabledOnLocationEmail = false;

    // Contact entity
    isEnabledOnContactTask = false;
    isEnabledOnContactNote = false;
    isEnabledOnContactCall = false;
    isEnabledOnContactMeeting = false;
    isEnabledOnContactEmail = false;

    // Job entity
    isEnabledOnJobTask = false;
    isEnabledOnJobNote = false;
    isEnabledOnJobCall = false;
    isEnabledOnJobMeeting = false;
    isEnabledOnJobEmail = false;

    // Booking entity
    isEnabledOnBookingTask = false;
    isEnabledOnBookingNote = false;
    isEnabledOnBookingCall = false;
    isEnabledOnBookingMeeting = false;
    isEnabledOnBookingEmail = false;

    // Campaign entity
    isEnabledOnCampaignTask = false;
    isEnabledOnCampaignNote = false;
    isEnabledOnCampaignCall = false;
    isEnabledOnCampaignMeeting = false;
    isEnabledOnCampaignEmail = false;

    // Opportunity entity
    isEnabledOnOpportunityTask = false;
    isEnabledOnOpportunityNote = false;
    isEnabledOnOpportunityCall = false;
    isEnabledOnOpportunityMeeting = false;
    isEnabledOnOpportunityEmail = false;
}
